/**
 * Wynwood Walls — cookie consent
 *
 * Behavior:
 *  - First visit (no cookie): show the slim bottom bar.
 *  - Accept: set cookie + grant Shopify Customer Privacy + load Contentsquare.
 *  - Decline: set cookie + deny Shopify Customer Privacy + DO NOT load Contentsquare.
 *  - Subsequent visits: silently restore the saved choice; no banner.
 *  - Reopen anytime via window.WynwoodCookies.open()
 *
 * Cookie: ww_cc=accept|decline ; 365 days ; SameSite=Lax
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'ww_cc';
  var COOKIE_DAYS = 365;
  var CONTENTSQUARE_SRC = 'https://t.contentsquare.net/uxa/bf9b281bbda6a.js';

  // ---------- cookie helpers ----------
  function readCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(prefix) === 0) {
        return decodeURIComponent(parts[i].substring(prefix.length));
      }
    }
    return null;
  }

  function writeCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      expires = '; expires=' + d.toUTCString();
    }
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax' + secure;
  }

  // ---------- third-party gating ----------
  function loadContentsquare() {
    if (document.querySelector('script[data-ww-csq]')) return;
    var s = document.createElement('script');
    s.src = CONTENTSQUARE_SRC;
    s.async = true;
    s.setAttribute('data-ww-csq', '');
    document.head.appendChild(s);
  }

  function setShopifyConsent(granted) {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: !!granted,
            marketing: !!granted,
            preferences: !!granted,
            sale_of_data: !!granted,
          },
          function () {}
        );
      }
    } catch (e) {
      /* ignore — API not yet loaded */
    }
  }

  function dispatchConsent(state) {
    try {
      document.dispatchEvent(new CustomEvent('ww:cookie-consent', { detail: { state: state } }));
    } catch (e) {}
  }

  // ---------- banner control ----------
  function getBar() {
    return document.getElementById('ww-cookie-bar');
  }

  function showBar() {
    var bar = getBar();
    if (!bar) return;
    bar.hidden = false;
    // next frame so the transform transition runs
    requestAnimationFrame(function () {
      bar.setAttribute('data-visible', 'true');
    });
  }

  function hideBar() {
    var bar = getBar();
    if (!bar) return;
    bar.removeAttribute('data-visible');
    setTimeout(function () {
      bar.hidden = true;
    }, 360);
  }

  function applyChoice(state, persist) {
    if (persist) writeCookie(COOKIE_NAME, state, COOKIE_DAYS);
    if (state === 'accept') {
      setShopifyConsent(true);
      loadContentsquare();
    } else {
      setShopifyConsent(false);
    }
    dispatchConsent(state);
    hideBar();
  }

  function wireButtons() {
    var bar = getBar();
    if (!bar) return;
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ww-cookie-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-ww-cookie-action');
      if (action === 'accept' || action === 'decline') {
        applyChoice(action, true);
      }
    });
  }

  function init() {
    // Don't show inside the theme editor — gets in the way.
    if (window.Shopify && window.Shopify.designMode) {
      return;
    }

    wireButtons();

    var saved = readCookie(COOKIE_NAME);
    if (saved === 'accept') {
      applyChoice('accept', false); // re-apply, but don't re-write
    } else if (saved === 'decline') {
      applyChoice('decline', false);
    } else {
      // First visit: deny by default until user chooses.
      setShopifyConsent(false);
      showBar();
    }
  }

  // ---------- public API ----------
  window.WynwoodCookies = {
    open: function () {
      var bar = getBar();
      if (bar) showBar();
    },
    accept: function () {
      applyChoice('accept', true);
    },
    decline: function () {
      applyChoice('decline', true);
    },
    reset: function () {
      writeCookie(COOKIE_NAME, '', -1);
      location.reload();
    },
    state: function () {
      return readCookie(COOKIE_NAME);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
